import React from 'react';
import { Reveal } from './Reveal';
import { ClockIcon, CrossIcon, FlameIcon, LockIcon } from './icons/Icons';
const symptoms = [{
  icon: FlameIcon,
  text: 'Ese ardor que sube por tu garganta después de comer.'
}, {
  icon: LockIcon,
  text: 'La comida que se te “atora” y la presión en el pecho.'
}, {
  icon: ClockIcon,
  text: 'Las noches sin dormir por el reflujo.'
}, {
  icon: CrossIcon,
  text: 'La dependencia total al Omeprazol o al Melox.'
}];
export function AgitationSection() {
  return <section className="w-full bg-[#f7f4ec] py-16 sm:py-24" data-id="element-23" data-mp="3lacqi2w2ky68">
      <div className="mx-auto max-w-4xl px-5" data-id="element-24" data-mp="3l8jkmpta6hza">
        <Reveal data-id="element-25" data-mp="3q1cs3lg4w4f2">
          <p className="text-center text-xs font-extrabold uppercase tracking-[0.18em] text-[#698b68]" data-id="element-26" data-mp="3q2xnfda9vrdz">Identificación del problema</p>
          <h2 className="mt-3 text-center font-display text-3xl font-black leading-tight text-[#29312c] sm:text-5xl" data-id="element-27" data-mp="3v2iktj9snrol">
            No estás loca. Y no, no es <span className="text-[#698b68]" data-id="element-28" data-mp="7x1d4w0zwxxj">“solo estrés”.</span>
          </h2>
        </Reveal>

        <Reveal delay={0.08} data-id="element-29" data-mp="2tty120i7u62a">
          <div className="mx-auto mt-8 max-w-2xl space-y-3 rounded-2xl border border-[#698b68]/15 bg-white p-5 text-base text-[#4f5b52] shadow-sm sm:p-7 sm:text-lg" data-id="element-30" data-mp="2tv0twdz3miku">
            <p data-id="element-31" data-mp="2ks846f5keex4">“Come más sano” <span className="text-[#8a4b37]" data-id="element-32" data-mp="2ktsx60c8dpsv">— pero ya casi no comes nada.</span></p>
            <p data-id="element-33" data-mp="2fuygp51qkdbx">“Es estrés, relájate” <span className="text-[#8a4b37]" data-id="element-34" data-mp="2fvhp9v5hxpda">— como si pudieras.</span></p>
            <p data-id="element-35" data-mp="3dgnforphmf3p">“Tómate esta pastilla” <span className="text-[#8a4b37]" data-id="element-36" data-mp="3dgvrshdsdgdu">— que solo funciona un rato.</span></p>
          </div>
        </Reveal>

        <div className="mt-8 grid gap-4 sm:grid-cols-2" data-id="element-37" data-mp="38kou1bvjnb6z">
          {symptoms.map((item, index) => <Reveal key={item.text} delay={0.1 + index * 0.05} data-id="element-38" data-mp="33pizxprzmq7t" data-mpi={index}>
              <div className="flex h-full items-start gap-4 rounded-2xl bg-[#edf2e8] p-5" data-id="element-39" data-mp="2yrzmut710jhg">
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-[#698b68] text-white" data-id="element-40" data-mp="3kbp2rbv21g">
                  <item.icon className="h-6 w-6" strokeWidth={2} data-id="element-41" data-mp="3rg59jlhn4ijx" />
                </span>
                <p className="font-semibold leading-relaxed text-[#334039]" data-id="element-42" data-mp="1pkftwrgc95q0">{item.text}</p>
              </div>
            </Reveal>)}
        </div>

        <Reveal delay={0.18} data-id="element-43" data-mp="1fumknx3o52ox">
          <div className="mx-auto mt-14 max-w-3xl border-l-4 border-[#a9492f] pl-5 sm:pl-7" data-id="element-44" data-mp="1ftbfptyhlow8">
            <h3 className="font-display text-2xl font-black text-[#29312c] sm:text-3xl" data-id="element-45" data-mp="1ks60h1g0lniz">¿Y sabes qué es lo más peligroso?</h3>
            <div className="mt-5 space-y-4 text-lg leading-relaxed text-[#4f5b52]" data-id="element-46" data-mp="15uly82ai66gi">
              <p data-id="element-47" data-mp="1awl1lc68t3dg">Que cada día que dejas tu mucosa “en carne viva”, el problema se hace más profundo.</p>
              <p data-id="element-48" data-mp="wwthctp4uqr0">El ardor de hoy puede convertirse en úlceras mañana. La dependencia a los antiácidos hace que tu cuerpo produzca más ácido por efecto rebote, atrapándote en un círculo del que parece imposible salir.</p>
              <p data-id="element-49" data-mp="2r76tozdnnrlv">Y mientras tanto, sigues perdiéndote la vida: las cenas, los viajes, el simple placer de comer un plato de tu comida favorita sin pagarlo con horas de dolor.</p>
              <p className="font-display text-2xl font-black text-[#698b68]" data-id="element-50" data-mp="36ct29qksovz7">No tiene por qué ser así.</p>
            </div>
          </div>
        </Reveal>
      </div>
    </section>;
}